import Icon from '../components/Icon.vue'

Icon.register({
  'sticky-note': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M312 320c-13.2 0-24 10.8-24 24v136h-264c-13.3 0-24-10.7-24-24v-400c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24v264h-136zM441 375l-98 98c-4.5 4.5-10.6 7-17 7h-6v-128h128v6.1c0 6.3-2.5 12.4-7 16.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sticky-note.js
// module id = 1951
// module chunks = 0